import { Step, StepLabel, Stepper } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { LabelProps, TableHeaderProps } from "../../../../../../utils/types";
import { Label } from "../../../../../../stories/Label/Label";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import Input from "../../../../../../stories/Input/Input";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
} from "@mui/x-data-grid-pro";
import Accepted from "../../../../../../images/ApprovedStatus.svg";
import Rejected from "../../../../../../images/RejectedStatus.svg";

import {
  StyledDatagrid,
  useDataGridStyles,
} from "../../../../../../styles/DatagridStyles";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { Button } from "../../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import Assign from "../../../../../../images/Assign.svg";
import Update from "../../../../../../images/Edit.svg";
import {
 
  toInputStandardDate,
} from "../../../../../../utils/UtilFunctions";
import Download from "../../../../../../images/DownloadImage.svg";
import Warning from "../../../../../../images/Warning.svg";
import Modal from "react-modal";
import { EditModalStyles } from "../../../../../../styles/CustomModalStyles";
import { Title } from "../../../../../../stories/Title/Title";
import {
  quotationDetailsForm,
} from "../../../../../../utils/formTypes";
import {

  AtsRfqTrnSupplyQuotationDetails,
  CheckIfQuoteSubmittedResult,
  GetRfqTrnSupplyByKeyForQuotationDetailsResult,
  GetRfqTrnSupplyByKeyVar,
 
  SubmitQuotationResult,
  SubmitQuotationVars,
} from "../queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  EMPTY_STRING,
  emptyMessage,

} from "../../../../../../utils/constants";
import { rfqInputJson } from "./Preview";
import {
  CheckIfQuoteSubmitted,
  GetRfqTrnSupplyByKey,
} from "../queries/queries";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { Operation, YesNo } from "../../../../../../utils/Enum.types";
import { SubmitQuotation } from "../queries/mutations";
import MessageModal from "../../../../../../customComponents/MessageModal";
import LoadingModal from "../../../../../pages/LoadingModal";
import useLabels from "../../../../../../customHooks/useLabels";


export const QuotationFormHeader = () => {
  return ["Quotation Details", "Supplier Terms and Conditions"];
};

export interface QuotationFormProps {
  step: number;
  //   setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const QuotationForm = ({ step }: QuotationFormProps) => {
  const { Purchase } = useAssetTableJson();
  const stepsHeader = QuotationFormHeader();
  const { headerStyles } = useDataGridStyles();
  const navigate = useNavigate();
  const { uuid } = useUrlParams();
  const [reQuoteModal, setReQuoteModal] = useState(false);
  const [rfqTrnSupplyId, setRfqTrnSupplyId] = useState(0);

  const [message, setMessage] = useState(emptyMessage);

  const [SubmitQuote] = useMutation<SubmitQuotationResult, SubmitQuotationVars>(
    SubmitQuotation
  );
  const [GetRfqTrans, { data, loading, fetchMore }] = useLazyQuery<
    GetRfqTrnSupplyByKeyForQuotationDetailsResult,
    GetRfqTrnSupplyByKeyVar
  >(GetRfqTrnSupplyByKey);

  const [CheckSubmitted, { data: checkSubData }] = useLazyQuery<
    CheckIfQuoteSubmittedResult,
    GetRfqTrnSupplyByKeyVar
  >(CheckIfQuoteSubmitted);

  const [items, setItems] = useState<AtsRfqTrnSupplyQuotationDetails[]>([]);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [searchData, setSearchData] = useState("");

  const initialValue: quotationDetailsForm = {
    lastDateForSubmission: "",
    gstNo: "",
    companyName: "",
    rfqNo: "",
    panNo: "",
    city: "",
    narration: "",
  };

  const [formData, setFormData] = useState<quotationDetailsForm>(initialValue);

  const renderCellBasedOnValue = (params: GridCellParams) => {
    if (params.value === YesNo.YES) {
      return (
        <img
          src={Accepted}
          alt="Accepted"
          className="view-pending__tableblock--pending"
        />
      );
    } else if (params.value === YesNo.NO) {
      return (
        <img
          src={Rejected}
          alt="Rejected"
          className="view-pending__tableblock--pending"
        />
      );
    }
    return <span>-</span>;
  };
  const dynamicHeaders: TableHeaderProps[] =
    Purchase.Quotation.Login.FillForm.map((header) => {
      const dynamicHeader: TableHeaderProps = {
        headerName: header.headerName,
        field: header.field,
        headerAlign: header.headerAlign as GridAlignment,
        align: header.align as GridAlignment,
        flex: header.flex,
        cellClassName: header.cellClassName,
        hideable: header.hideable,
      };

      const fieldsWithCustomRender = [
        "interested_to_quote",
        "if_any_change_in_desc",
        "any_other_charges_per_qty",
      ];

      if (fieldsWithCustomRender.includes(header.field)) {
        dynamicHeader.renderCell = renderCellBasedOnValue;
      } else if (header.field === "actions") {
        dynamicHeader.renderCell = (params: GridCellParams) => (
          <>
            {params.row.quotedCompleted ? (
              <button className="quotation-form__block--update">
                Update <img src={Update} alt="" />
              </button>
            ) : (
              <button
                className="quotation-form__block--generate"
                onClick={() => {
                  navigateToDetails(params.row.rfqTrnSupplyId);
                }}
              >
                Generate
                <img src={Assign} alt="" />
              </button>
            )}
          </>
        );
      } else if (header.field === "upload_product_details") {
        dynamicHeader.renderCell = (params: GridCellParams) => (
          <div className="quotation-form__block--file">
            {/* <img src={getFileIcon(params.row.upload_product_details)} alt="" /> */}
            {params.row.upload_product_details}
            <img src={Download} alt="" />
          </div>
        );
      }
      return dynamicHeader;
    });
  const columns: GridColDef[] = [...dynamicHeaders];

  useEffect(() => {
    if (uuid) {
      GetRfqTrans({
        variables: {
          key: uuid,
        },
      }).then(({ data }) => {
        if (
          data &&
          data.GetRfqTrnSupplyByKey &&
          data.GetRfqTrnSupplyByKey.length
        ) {
          const firstElement = data.GetRfqTrnSupplyByKey[0];
          const rfqDetails = firstElement.rfq;
          const supplier_details = firstElement.supplierDetails;

          setFormData({
            city: supplier_details.supplier_details.city,
            companyName: supplier_details.desc,
            gstNo: supplier_details.supplier_details.gstNo,
            lastDateForSubmission: toInputStandardDate(
              rfqDetails.lastDateRfqSubmission
            ),
            narration: rfqDetails.remarks,
            panNo: supplier_details.supplier_details.panNo,
            rfqNo: rfqDetails.rfqNo,
            generalPaymentTerms: firstElement.rfq.generalPaymentTerms,
            generalTerms: firstElement.rfq.generalTerms,
          });

          setItems(data.GetRfqTrnSupplyByKey);
        }
      });
    }
  }, [GetRfqTrans, searchData, data]);

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "total_amount":
        case "delivery_charges":
        case "installation_charges":
        case "net_quoted":
          return "total-count";

        case "tax_perc":
          return "total";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  const itemsList = useMemo(() => {
    return items.filter((itm) =>
      itm.itemDescChanged
        ? itm.quotedDesc.toLowerCase().includes(searchData)
        : itm.rfqTrn.udfItemDesc.toLowerCase().includes(searchData) ||
          searchData === ""
    );
  }, [searchData, data, items]);

  const rowsData = useMemo(() => {
    return itemsList.map((itm, index) => {
      const total =
        itm.quotedRate * itm.quotedQty +
        itm.quotedDelvChrg +
        itm.quotedInstChrg;

      return {
        id: index + 1,
        item_desc: itm.itemDescChanged
          ? itm.itemDescChanged
          : itm.rfqTrn.udfItemDesc,
        required_qty: itm.rfqTrn.mrf_trn_details.reqQty,
        terms: itm.rfqTrn.itemTerms,
        payment_terms: itm.rfqTrn.itemPaymentTerms,
        interested_to_quote: itm.isAccepted ? YesNo.YES : YesNo.NO,
        if_any_change_in_desc: itm.itemDescChanged ? YesNo.YES : YesNo.NO,
        if_any_change_in_desc_specify: itm.quotedDesc,
        quoted_qty: itm.quotedQty,
        rate: itm.quotedRate,
        any_other_charges_per_qty: itm.quotedAnyChanges ? YesNo.YES : YesNo.NO,
        tax_perc: itm.quotedTax,
        total_amount: total ? total : EMPTY_STRING,
        delivery_charges: itm.quotedDelvChrg,
        installation_charges: itm.quotedInstChrg,
        net_quoted: itm.quotedValue,
        remarks: itm.quotedRemarks,
        rfqTrnSupplyId: itm.id,
        quotedCompleted: itm.quotedCompleted,
        upload_product_details: "",
      };
    });
  }, [itemsList, searchData, data]);

  const totals = useMemo(() => {
    return itemsList.reduce(
      (acc, itm) => {
        const total =
          itm.quotedRate * itm.quotedQty +
          itm.quotedDelvChrg +
          itm.quotedInstChrg +
          itm.quotedOther;

        const netValue = (itm.quotedTax / 100) * total;
        acc.deliverCharges = itm.quotedDelvChrg + acc.deliverCharges;
        acc.installationCharges = itm.quotedInstChrg + acc.installationCharges;
        acc.netQuoted = netValue + acc.netQuoted;
        acc.totalAmt = total + acc.totalAmt;

        return acc;
      },
      {
        totalAmt: 0,
        deliverCharges: 0,
        installationCharges: 0,
        netQuoted: 0,
      }
    );
  }, [itemsList, data]);

  const getRow = () => {
    if (itemsList.length) {
      return [
        {
          id: [],
          item_desc: [],
          required_qty: [],
          terms: [],
          payment_terms: [],
          interested_to_quote: [],
          if_any_change_in_desc: [],
          if_any_change_in_desc_specify: [],
          quoted_qty: [],
          rate: [],
          any_other_charges_per_qty: [],
          tax_perc: "Total",
          total_amount: totals.totalAmt,
          delivery_charges: totals.deliverCharges,
          installation_charges: totals.installationCharges,
          net_quoted: totals.netQuoted,

          remarks: [],
          upload_product_details: [],
          actions: [],
        },
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow(),
  };

  const navigateToDetails = (rfqTrnSupplyId: number) => {
    if (uuid) {
      CheckSubmitted({
        variables: {
          key: uuid,
        },
      }).then(({ data }) => {
        if (data && data.CheckIfQuoteSubmitted) {
          navigate(
            `/vendor/${uuid}/quotationform/details/${rfqTrnSupplyId}/fill_item`
          );
        } else {
          setRfqTrnSupplyId(rfqTrnSupplyId);
          setReQuoteModal(true);
        }
      });
    }
  };

  const handleSubmitQuote = () => {
    if (uuid)
      SubmitQuote({
        variables: {
          uuid,
        },
      }).then(({ data }) => {
        if (data && data.SubmitQuotation) {
          setMessage({
            flag: true,
            message: "Submitted Quote",
            operation: Operation.CREATE,
          });
        }
      });
  };

  useEffect(() => {
    if (uuid)
      CheckSubmitted({
        variables: {
          key: uuid,
        },
      });
  }, [CheckSubmitted, uuid]);
  const {itemLabel}=useLabels();
  return (
    <>
      <div className="quotation-form">
        <div className="quotation-form__block">
          <div className="quotation-form__block--header">
            <b>Fill Quotation Form</b>
          </div>
          <div className="quotation-form__block--stepper">
            <Stepper alternativeLabel activeStep={step - 1}>
              {stepsHeader.map((step, index) => {
                return (
                  <Step key={index}>
                    <StepLabel>{step}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>

          <div className="quotation-preview__block--filters">
            {rfqInputJson.map((array, colIndex) => (
              <div key={colIndex}>
                {array.map((label: LabelProps) => {

                  return (
                    <div className="quotation-preview__block--filters--grid">
                      <Label>{label.labelName}</Label>
                      {label.dataType === "textarea" ? (
                        <TextArea
                          rows={3}
                          value={formData[label.inputName]}
                          disabled
                        />
                      ) : (
                        <Input
                          disabled
                          type={label.dataType}
                          value={formData[label.inputName]}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
          <div className="quotation-preview__block--input row g-0">
            <div className="col-2">
              <Input id="data_search" placeholder="Search..." />
            </div>
            <div className="col flex-end">
              <div className="overall-total-count">
                Total {itemLabel} Requested <b>0</b>
              </div>
            </div>
          </div>

          <div className="quotation-form__block--tableblock">
            <StyledDatagrid
              columns={columns}
              rows={rowsData}
              rowHeight={TABLE_ROW_HEIGHT}
              // onCellClick={(params) => {
              //   if (params.field === "prefered_vendor") {
              //     setSelectedSuppliers(!selectedSuppliers);
              //   }
              // }}
              sx={{
                ...headerStyles,
              }}
              disableRowSelectionOnClick
              hideFooter
              pinnedRows={pinnedRows}
              getCellClassName={getCellClassName}
              initialState={{
                pinnedColumns: {
                  left: [
                    "id",
                    "item_desc",
                    "required_qty",
                    "terms",
                    "payment_terms",
                  ],
                  right: ["actions"],
                },
              }}
            />
          </div>
          <div className="quotation-form__block--buttons">
            <Button
              onClick={handleSubmitQuote}
              disabled={
                checkSubData && checkSubData.CheckIfQuoteSubmitted
                  ? false
                  : true
              }
            >
              <img src={Assign} alt="" />
              Submit Quotation
            </Button>
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
        </div>
      </div>
      <LoadingModal flag={loading} />
      <Modal
        isOpen={confirmationModal}
        style={EditModalStyles}
        ariaHideApp={false}
      >
        <div className="quotation-form__confirm">
          <img
            src={Warning}
            alt=""
            className="quotation-form__confirm--warning"
          />
          <Title>Please Complete</Title>
          <p>
            If you want to submit the form Please fill all the details before
            submitting the form.
          </p>
          <div className="quotation-form__confirm--buttons">
            <Button
              mode="okay"
              onClick={() => setConfirmationModal(!confirmationModal)}
            />
          </div>
        </div>
      </Modal>
      <Modal isOpen={reQuoteModal} style={EditModalStyles} ariaHideApp={false}>
        <div className="quotation-form__confirm">
          <img
            src={Warning}
            alt=""
            className="quotation-form__confirm--warning"
          />
          <Title>Warning</Title>
          <p>Quote has already been submitted do you like to resubmit</p>
          <div className="quotation-form__confirm--buttons">
            <Button
              mode="okay"
              onClick={() => {
                setReQuoteModal(false);
                navigate(
                  `/vendor/${uuid}/quotationform/details/${rfqTrnSupplyId}/fill_item`
                );
              }}
            />
          </div>
        </div>
      </Modal>
      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default QuotationForm;
